import React from 'react'

export type NavigatorTheme = 'primary' | 'secondary'

export interface INavigatorContext {
  compact: boolean
  theme: NavigatorTheme
}

export interface INavigatorItemContext {
  active: boolean
  hovering: boolean
  theme: NavigatorTheme
}

export const NavigatorContext = React.createContext<INavigatorContext>({
  compact: false,
  theme: 'primary',
})

export const NavigatorItemContext = React.createContext<INavigatorItemContext>({
  active: false,
  hovering: false,
  theme: 'primary',
})
